import React from 'react'
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
} from '@mui/material'
import StarIcon from '@mui/icons-material/Star'
import GoogleIcon from '@mui/icons-material/Google'

const reviews = [
  {
    name: 'Rob',
    review:
      "I can't recommend pulse pallets any higher Freddie is 100% reliable and and very friendly, pulse pallets are a regular to collect pallets from my workplace and have always been nothing but professional.",
  },
  {
    name: 'Connie',
    review:
      'Bought a planter for my rose tree a couple of years ago and was very happy experience. Fast delivery to door, excellent customer service. Would definitely recommend if you want a bespoke pallet planter!',
  },
  {
    name: 'Billy',
    review:
      'Great quality wooden pallet collars for my allotment. Great customer service from Freddy. Friendly and supported me in putting them in my car and made sure that will fit them all. Will order more soon as taken another plot.',
  },
]

// Replace this with the actual Google Business Profile URL
const googleReviewsUrl = 'https://www.google.com/maps/place/Pulse+Pallets/@51.2527086,-1.2267807,9z/data=!4m8!3m7!1s0x289d42ba8a9625fb:0x6544d25b48a8d564!8m2!3d51.2527086!4d-1.2267807!9m1!1b1!16s%2Fg%2F11zg7wjlwb?entry=ttu&g_ep=EgoyMDI2MDkzMC4wIKXMDSoASAFQAw%3D%3D'

const Testimonials = () => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 10 },
        px: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: '1200px',
          mx: 'auto',
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: '#fff',
            fontWeight: 700,
            textAlign: 'center',
            mb: 2,
          }}
        >
          What Our Customers Say
        </Typography>

        <Typography
          sx={{
            color: '#d7e3dd',
            textAlign: 'center',
            maxWidth: '700px',
            mx: 'auto',
            mb: 6,
            lineHeight: 1.8,
          }}
        >
          We're committed to providing reliable pallet solutions and
          outstanding customer service. Here are some of the reviews
          we've received from our customers.
        </Typography>

        <Grid
          container
          spacing={3}
          justifyContent="center"
        >
          {reviews.map((review, index) => (
            <Grid
              item
              xs={12}
              md={4}
              key={index}
            >
              <Card
                sx={{
                  height: '100%',
                  backgroundColor: '#222023',
                  border: '1px solid rgba(87,200,77,0.15)',
                  transition: 'all 0.3s ease',

                  '&:hover': {
                    borderColor: '#57C84D',
                    transform: 'translateY(-4px)',
                  },
                }}
              >
                <CardContent
                  sx={{
                    textAlign: 'center',
                    p: 4,
                  }}
                >
                  <Typography
                    sx={{
                      color: '#fff',
                      fontWeight: 700,
                      mb: 1,
                      fontSize: '1.1rem',
                    }}
                  >
                    {review.name}
                  </Typography>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      mb: 3,
                    }}
                  >
                    {[...Array(5)].map((_, i) => (
                      <StarIcon
                        key={i}
                        sx={{
                          color: '#FFD700',
                          fontSize: 22,
                        }}
                      />
                    ))}
                  </Box>

                  <Typography
                    sx={{
                      color: '#d7e3dd',
                      lineHeight: 1.8,
                    }}
                  >
                    "{review.review}"
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* GOOGLE BUTTON */}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mt: 6,
          }}
        >
          <Button
            size="large"
            component="a"
            href={googleReviewsUrl}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<GoogleIcon />}
            sx={{
              backgroundColor: '#0A9B48',
              color: '#fff',
              minWidth: '220px',
              py: 2,
              px: 4,
              fontSize: '1rem',
              fontWeight: 700,
              letterSpacing: '1px',
              borderRadius: 0,
              transition: 'all 0.3s ease',

              '&:hover': {
                transform: 'translateY(-4px)',
                borderColor: '#fff',
                border: '1px solid',
                boxShadow: '0 10px 30px rgba(87,200,77,0.15)',
                backgroundColor: '#57C84D',
              },
            }}
          >
            READ MORE REVIEWS →
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default Testimonials